if (!customElements.get("hero-carousel-component")) {
  customElements.define(
    "hero-carousel-component",
    class HeroCarouselComponent extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = null;
        this.initSlider();
      }

      initSlider() {
        const autoplayEnabled = this.dataset.autoplay === "true";
        const autoplayDelay = parseInt(this.dataset.delay, 10) || 5000;
        const paginationElement = this.querySelector(".swiper-pagination");

        const options = {
          slidesPerView: 1,
          effect: "fade",
          fadeEffect: {
            crossFade: false,
          } /* Prevents the opacity drop that causes the white flash */,
          speed: 600 /* Makes the transition timing much smoother */,
          loop: true,
          allowTouchMove: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          on: {
            init: (swiper) => {
              this.animateTextElements(swiper.slides[swiper.activeIndex]);
            },
            slideChangeTransitionStart: (swiper) => {
              // First, reset all currently processed elements
              this.resetAllTextElements(swiper);
              // Then manually trigger animation loop on newly active slide
              this.animateTextElements(swiper.slides[swiper.activeIndex]);
            },
          },
        };

        if (paginationElement) {
          options.pagination = {
            el: paginationElement,
            clickable: true,
          };
        }

        if (autoplayEnabled) {
          options.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        // Add Swiper modules per standard Sleek integration
        const modules = [
          window.FoxTheme.Swiper.EffectFade,
          window.FoxTheme.Swiper.Navigation,
        ];

        if (autoplayEnabled && window.FoxTheme.Swiper.Autoplay) {
          modules.push(window.FoxTheme.Swiper.Autoplay);
        }
        if (paginationElement && window.FoxTheme.Swiper.Pagination) {
          modules.push(window.FoxTheme.Swiper.Pagination);
        }

        // Initialize Swiper instance
        this.sliderInstance = new window.FoxTheme.Carousel(
          this,
          options,
          modules,
        );
        this.sliderInstance.init();
      }

      resetAllTextElements(swiper) {
        swiper.slides.forEach((slide) => {
          const motionEls = slide.querySelectorAll("motion-element[data-text]");
          motionEls.forEach((el) => {
            if (typeof el.resetAnimation === "function") {
              el.resetAnimation();
            }
          });
        });
      }

      animateTextElements(slide) {
        if (!slide) return;

        // Enforce minor JS lag offset to guarantee `swiper-slide-active` CSS class propagates first
        setTimeout(() => {
          const motionEls = slide.querySelectorAll("motion-element[data-text]");
          motionEls.forEach((el) => {
            if (typeof el.refreshAnimation === "function") {
              el.refreshAnimation();
            }
          });
        }, 50);
      }
    },
  );
}
